var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('span',{style:({position: 'absolute',
        border: '2px solid #000!important',
        width: '1em', 
        transform:'translate('+_vm.shift+'px,4px)',           
        height: '1em',           
        fontSize: '1.0em'})},[_c('div',{style:({transform:'translate('+_vm.shiftmark+'px,-6px)'}),domProps:{"innerHTML":_vm._s(_vm.getCheck())}})]),_c('div',{style:({display:'inline-block', textIndent: _vm.getShift() }),domProps:{"innerHTML":_vm._s(_vm.text)}},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }